import _extends from "@babel/runtime/helpers/extends";
/* eslint { jsx-a11y/no-noninteractive-tabindex: 0,
			jsx-a11y/click-events-have-key-events: 0,
			jsx-a11y/no-static-element-interactions: 0 } */

import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { FocusScope } from '@react-aria/focus';
import ModalFooter, { propTypes as modalFooterPropTypes } from './ModalFooter';
import Button from '@pattern-library/buttons';
import { FocusService } from '@pattern-library/utils';
import { XBoldIcon } from '@pattern-library/icon';
import classnames from 'classnames';
const NO_SCROLL_CLASS = 'asc-no-scroll';
class Modal extends Component {
  constructor(props) {
    super(props);
    this.onOpen = () => {
      document.body.addEventListener('keydown', this.handleKey);
      document.body.classList.add(NO_SCROLL_CLASS);
      document.getElementsByTagName('html')[0].classList.add(NO_SCROLL_CLASS);
      FocusService.focusFirstElementIn(this.modalNode);
    };
    this.onClose = () => {
      document.body.removeEventListener('keydown', this.handleKey);
      document.body.classList.remove(NO_SCROLL_CLASS);
      document.getElementsByTagName('html')[0].classList.remove(NO_SCROLL_CLASS);
      this.focusOnTriggerButton();
    };
    this.handleKey = event => {
      if (event.keyCode === 27) {
        this.handleCloseModal();
      }
    };
    this.handleCloseModal = () => {
      const {
        closeModal,
        preventClose
      } = this.props;
      if (preventClose !== true) {
        closeModal();
      }
    };
  }
  componentDidMount() {
    if (this.props.isActive) {
      this.onOpen();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.isActive && !prevProps.isActive) {
      this.onOpen();
    } else if (!this.props.isActive && prevProps.isActive) {
      this.onClose();
    }
  }
  componentWillUnmount() {
    this.onClose();
  }
  focusOnTriggerButton() {
    const {
      triggerButtonRef
    } = this.props;
    if (triggerButtonRef && triggerButtonRef.current) {
      FocusService.focusElement(triggerButtonRef.current);
    }
  }
  render() {
    const {
      ariaLabel,
      bottomGradient,
      children,
      className,
      closeModal,
      closeOnMaskClick,
      contentAreaBackgroundColor,
      contentContainerRef,
      desktopOnly,
      footerButtonAlignment,
      footerButtonBlock,
      footerButtonBlockDirection,
      footerButtons,
      footerChildren,
      footerCloseButtonClasses,
      footerCloseButtonText,
      hasFooter,
      hasFooterClose,
      headerStyle,
      headerText,
      id,
      isActive,
      maxHeight,
      modalAttrs,
      paddingWidth,
      preventClose,
      usePortal,
      widthClassNames,
      zIndex
    } = this.props;
    const hasVisibleHeader = Boolean(headerText);
    const showCloseButton = preventClose !== true;
    const wrapperClasses = !desktopOnly && isActive ? 'asc-modal-responsive-wrapper' : '';
    const baseClasses = 'asc-modal asc-modal--hidden asc-modal-animated ' + widthClassNames;
    const classes = isActive ? `${baseClasses} asc-modal-is-active` : baseClasses;
    const viewportClasses = classnames('asc-modal-viewport', {
      'asc-modal-viewport--no-padding': paddingWidth === 'none',
      'asc-modal-viewport--no-header': !hasVisibleHeader
    }, `asc-modal-viewport-background--${contentAreaBackgroundColor}`);
    const markup = /*#__PURE__*/React.createElement("div", {
      className: classnames(wrapperClasses, className),
      style: {
        zIndex
      }
    }, /*#__PURE__*/React.createElement(FocusScope, {
      contain: isActive,
      autoFocus: false,
      restoreFocus: false
    }, /*#__PURE__*/React.createElement("div", _extends({
      className: classes,
      role: "dialog",
      "aria-label": ariaLabel,
      "aria-labelledby": hasVisibleHeader ? `${id}-title` : undefined,
      "aria-modal": "true",
      ref: node => {
        this.modalNode = node;
      },
      style: {
        zIndex
      },
      tabIndex: "-1"
    }, modalAttrs), /*#__PURE__*/React.createElement("div", {
      className: "asc-modal-inner",
      "data-role": "modal-inner"
    }, showCloseButton && /*#__PURE__*/React.createElement(Button, {
      className: "asc-btn--modal-close",
      clickHandler: closeModal,
      "aria-label": "close",
      text: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(XBoldIcon, {
        color: "gray-60"
      }), /*#__PURE__*/React.createElement("span", {
        className: "visually-hide"
      }, "Close"))
    }), /*#__PURE__*/React.createElement("div", {
      className: "asc-modal-inner-wrapper"
    }, hasVisibleHeader && /*#__PURE__*/React.createElement("div", {
      className: 'asc-modal-header ' + (headerStyle === 'large' || headerStyle === 'small' ? `asc-modal-header--${headerStyle}` : headerStyle)
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text--center",
      id: `${id}-title`
    }, headerText)), /*#__PURE__*/React.createElement("div", {
      className: viewportClasses,
      ref: contentContainerRef,
      style: {
        maxHeight: maxHeight
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: `asc-plr-fluid-${paddingWidth}`
    }, children), bottomGradient && /*#__PURE__*/React.createElement("div", {
      className: "asc-modal-viewport--bottom-gradient"
    })), hasFooter && /*#__PURE__*/React.createElement(ModalFooter, {
      hasFooterClose: hasFooterClose,
      footerCloseButtonClasses: footerCloseButtonClasses,
      footerCloseButtonText: footerCloseButtonText,
      footerButtons: footerButtons,
      footerChildren: footerChildren,
      closeHandler: closeModal,
      footerButtonAlignment: footerButtonAlignment,
      footerButtonBlock: footerButtonBlock,
      footerButtonBlockDirection: footerButtonBlockDirection
    })))), isActive && /*#__PURE__*/React.createElement("div", {
      className: classnames('asc-mask', {
        'asc-mask--noninteractive': closeOnMaskClick === false
      }),
      style: {
        zIndex: zIndex - 1
      },
      onClick: closeOnMaskClick ? this.handleCloseModal : undefined
    })));
    const canUsePortal = usePortal && typeof document === 'object';
    return canUsePortal ? /*#__PURE__*/createPortal(markup, document.body) : markup;
  }
}
Modal.propTypes = {
  /**
   * Unique ID required for connecting accessibility attributes in the DOM
   */
  id: PropTypes.string.isRequired,
  /**
   * Function to close the modal from its parent component
   **/
  closeModal: PropTypes.func.isRequired,
  /**
   * Aria label for the modal element. Required if `headerText` is not provided.
   */
  ariaLabel: PropTypes.string,
  /**
   * Has a gradient at the bottom of the content to indicate scrolling
   */
  bottomGradient: PropTypes.bool,
  /**
   * Content that appears in the body of the modal
   **/
  children: PropTypes.node,
  /**
   * Custom class to set on the modal container element
   */
  className: PropTypes.string,
  /**
   * Persists the modal thru background mask click
   */
  closeOnMaskClick: PropTypes.bool,
  /**
   * Content area background color
   */
  contentAreaBackgroundColor: PropTypes.oneOf(['white', 'gray-05']),
  /**
   * Forwards a ref from the parent to the content container div
   */
  contentContainerRef: PropTypes.object,
  /**
   * Non-responsive modal
   */
  desktopOnly: PropTypes.bool,
  /**
   * Array of buttons that should appear in the footer
   **/
  footerButtons: modalFooterPropTypes.footerButtons,
  /**
   * Alignment of the footer buttons
   */
  footerButtonAlignment: PropTypes.oneOf(['center', 'left', 'right', 'spread']),
  /**
   * Stack the buttons vertically, either at all viewports (if true) or at or
   * below the given viewport (if 'small' or 'medium').
   */
  footerButtonBlock: ModalFooter.propTypes.footerButtonBlock,
  /**
   * When in block style, buttons can either stack in "normal" or "reverse" order.
   * Defaults to normal.
   */
  footerButtonBlockDirection: ModalFooter.propTypes.footerButtonBlockDirection,
  /**
   * Add additional classes to the close button in the footer
   **/
  footerCloseButtonClasses: modalFooterPropTypes.footerCloseButtonClasses,
  /**
   * Update the text of the close button in the footer
   **/
  footerCloseButtonText: modalFooterPropTypes.footerCloseButtonText,
  /**
   * An element, node, or array of nodes that will appear in the modal footer.
   * This will override the footerButtons prop
   */
  footerChildren: modalFooterPropTypes.footerChildren,
  /**
   * Toggle the appearance of a footer section in the modal
   **/
  hasFooter: PropTypes.bool,
  /**
   * Toggle the appearance of a close button in the footer
   **/
  hasFooterClose: PropTypes.bool,
  /**
   * Header style
   * large: 20px
   * small: 14px
   * or pass a class name
   */
  headerStyle: PropTypes.oneOf(['large', 'small', PropTypes.string]),
  /**
   * Modal heading text
   **/
  headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * Toggle whether the modal should be displayed
   **/
  isActive: PropTypes.bool,
  /**
   * max-height style applied to the modal content area.
   * <br />Must be a valid CSS unit value.
   */
  maxHeight: PropTypes.string,
  /**
   * Additional HTML attributes to set on the modal <div>
   */
  modalAttrs: PropTypes.object,
  /**
   * Left and right padding on the content area, based in columns
   */
  paddingWidth: PropTypes.oneOf(['none', 'half', 'full']),
  /**
   * Toggle whether to prevent the closing of the modal.
   */
  preventClose: PropTypes.bool,
  /**
   * Reference of the trigger button element that opens the modal
   */
  triggerButtonRef: PropTypes.object,
  /**
   * When set to true, the modal will be rendered at the end of the body tag,
   * instead of where the component is instantiated on the page
   */
  usePortal: PropTypes.bool,
  /**
   * Define modal widths using pattern library layout .asc-col-X class names
   */
  widthClassNames: PropTypes.string,
  /**
   * Custom z-index value
   */
  zIndex: PropTypes.number
};
Modal.defaultProps = {
  bottomGradient: false,
  children: [],
  closeOnMaskClick: true,
  contentAreaBackgroundColor: 'white',
  desktopOnly: false,
  footerButtonAlignment: 'center',
  footerButtons: [],
  footerCloseButtonClasses: 'asc-btn--small asc-btn--secondary',
  footerCloseButtonText: 'Cancel',
  hasFooter: true,
  hasFooterClose: true,
  headerStyle: 'large',
  headerText: '',
  isActive: false,
  maxHeight: '40vh',
  modalAttrs: {},
  paddingWidth: 'full',
  usePortal: true,
  widthClassNames: 'asc-col-12 asc-col-md-10',
  zIndex: 100
};
export default Modal;